import Image from "next/image";
import { useEffect, useState } from "react";
import { conditions } from "helpers";
import { ConditionName, ITagsProps } from "interfaces";
import { handleClickPlayerCardTag, handleScrollLeft, handleScrollRight } from "redux-share/actions/tags.actions";
import IMAGES from "../../../../../images/importImages";

const Tags = ({ tags, usePlace, tagId }: ITagsProps) => {
    const [isHover, setIsHover] = useState<boolean>(false);
    const [isScrollable, setIsScrollable] = useState<boolean>(true);

    useEffect(() => {
        if (document.getElementById(tagId) && conditions(ConditionName.isComplexDesktop)) handleScroll();
    }, [document.getElementById(tagId)]);

    const handleScroll = () =>
        setIsScrollable(
            !!document.getElementById(tagId) &&
                Math.abs(
                    Math.abs(document.getElementById(tagId)!.scrollWidth) -
                        (document.getElementById(tagId)!.getBoundingClientRect().width + Math.abs(document.getElementById(tagId)!.scrollLeft))
                ) <= 1
        );

    return (
        <div
            className={`pl-relative pl-flex pl-items-center ${
                usePlace === "DesktopDescription" ? "pl-my-2 pl-gap-4" : "pl-gap-1 no-scrollbar pl-overflow-auto"
            }`}
            onMouseOut={() => setIsHover(false)}
            onMouseOver={() => setIsHover(true)}
        >
            {conditions(ConditionName.isComplexDesktop) && isHover && !isScrollable && (
                <div
                    className="pl-flex pl-absolute pl-left-0"
                    onClick={(event: any) => handleScrollLeft(event, tagId)}
                    style={{
                        width: 10,
                        height: 10
                    }}
                >
                    <Image
                        src={conditions(ConditionName.isDarkMode) ? IMAGES.rightArrow : IMAGES.lightRightArrow}
                        className={`pl-cursor-pointer pl-h-full pl-w-full`}
                        layout={"fill"}
                        alt="right-arrow"
                    />
                </div>
            )}
            <div
                className={`pl-flex pl-w-full pl-items-center ${
                    usePlace === "DesktopDescription" ? "pl-gap-4" : "pl-gap-1"
                } no-scrollbar pl-overflow-auto`}
                id={tagId}
            >
                {tags.split(",").map((tag: string, index: number) => (
                    <p
                        key={index}
                        onClick={(event: any) => handleClickPlayerCardTag(event, tag)}
                        style={{ direction: "ltr" }}
                        className={`pl-cursor-pointer ${
                            usePlace === "DesktopDescription"
                                ? "pl-text-[14px] pl-text-primary-800 dark:pl-text-primary-500 pl-font-medium"
                                : "pl-text-gray-800 dark:pl-text-dark-5 pl-bg-gray-100 dark:pl-bg-secondary-600 pl-px-2 pl-py-[3px] pl-rounded-[4px] pl-font-normal pl-min-w-max pl-text-[10px]"
                        }`}
                    >
                        {tag}
                        {usePlace === "DesktopDescription" && "#"}
                    </p>
                ))}
            </div>
            {conditions(ConditionName.isComplexDesktop) && isHover && !isScrollable && (
                <div
                    className="pl-flex pl-absolute pl-right-0"
                    onClick={(event: any) => handleScrollRight(event, tagId)}
                    style={{
                        width: 10,
                        height: 10
                    }}
                >
                    <Image
                        src={conditions(ConditionName.isDarkMode) ? IMAGES.leftArrow : IMAGES.lightLeftArrow}
                        className={`pl-cursor-pointer pl-h-full pl-w-full`}
                        layout={"fill"}
                        alt="left-arrow"
                    />
                </div>
            )}
        </div>
    );
};

export default Tags;
